import React from "react";
import PageWrapper from "./dicoveryQueue.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import DiscoveryQueueTabs from "components/discoveryQueue/DicoveryQueueTabs";

const DiscoveryQueue = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.discovery_queue"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.discovery_queue"
          }
        ]}
      />
      <div className="user-tbl">
        <DiscoveryQueueTabs {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.auth,
    ...state.themeChanger,
    auth: state.auth,
    ...state.permissionReducer
  };
};

export default connect(mapStateToProps, null)(DiscoveryQueue);
